import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const i18n = new VueI18n({
    locale: 'ru', // set the initial locale
    fallbackLocale: 'kz', // set the fallback locale
    messages: {},
    silentFallbackWarn: true, // disable warning message when fallback is used
})

export default i18n